module.exports = __webpack_public_path__ + "static/media/img14.65b6f357.jpg";